import React, { useState, useCallback, useEffect, useContext } from 'react';
import { useDocuments } from '../context/DocumentContext';
import { useLocation, useSearchParams } from 'react-router-dom';
import { TableContext } from '../components/shared/table/context/TableContext';
import DocumentList from '../components/Documents/DocumentList';
import DocumentUploadForm from '../components/Documents/DocumentUploadForm';

import LabelsContent from './LabelsContent';

const DocumentsContent = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'documents';
  const [selectedDocuments, setSelectedDocuments] = useState(new Set());
  const [showUploadForm, setShowUploadForm] = useState(false);
  const { documents: documentsList, loading, fetchDocuments } = useDocuments();
  const { filterText } = useContext(TableContext);
  const location = useLocation();

  useEffect(() => {
    fetchDocuments(filterText);
  }, [fetchDocuments, location.state?.refresh, filterText]);

  const refreshDocuments = useCallback(() => {
    fetchDocuments(filterText);
  }, [fetchDocuments, filterText]);

  const handleUpload = useCallback(() => {
    setShowUploadForm(true);
  }, []);

  const handleUploadSuccess = useCallback(() => {
    setShowUploadForm(false);
    fetchDocuments(filterText);
  }, [fetchDocuments, filterText]);

  return (
    <>
      <div className="container mx-auto p-4 h-full flex flex-col space-y-4">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8" aria-label="Tabs">
            <button
              onClick={() => setSearchParams({ tab: 'documents' })}
              className={`${
                activeTab === 'documents'
                  ? 'border-indigo-500 text-indigo-600'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              } whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium`}
            >
              Documents
            </button>
            <button
              onClick={() => setSearchParams({ tab: 'labels' })}
              className={`${
                activeTab === 'labels'
                  ? 'border-indigo-500 text-indigo-600'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              } whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium`}
            >
              Labels
            </button>
          </nav>
        </div>
        {activeTab === 'documents' ? (
          <div className="flex-1 min-h-0">
            <div className="h-full border rounded-lg shadow-sm bg-white">
              <DocumentList
                selectedDocuments={selectedDocuments}
                setSelectedDocuments={setSelectedDocuments}
                onUploadClick={handleUpload}
                onRefresh={refreshDocuments}
                documents={documentsList}
                loading={loading}
              />
            </div>
          </div>
        ) : (
          <LabelsContent />
        )}
      </div>
      <DocumentUploadForm
        open={showUploadForm}
        onClose={() => setShowUploadForm(false)}
        onSuccess={handleUploadSuccess}
      />
    </>
  );
};

export default DocumentsContent;
